module.exports = __webpack_public_path__ + "static/media/NewsAtNortheastern.dd7bebfb.svg";